app.service('deliveryValidateServices', function (loading, console, modal, orderUtils, orderConfig) {

	function validateSuccess(json) {
		console.log('SPRAWDZENIE USŁUG - OK');
		var data = json.message;
		if (data !== "") {
			loading.stop();
			modal.generate({
				header: false,
				id: 'modal-service-validate',
				content: '<p>' + data + '</p>',
				buttons: [
					{
						text: 'Rozumiem',
						cssClass: 'btn-second confirm-services-validation-result',
						click: function () {
							send('NEXT');
						}
					}
				]
			});
		} else {
			send('NEXT');
		}
	}
	function validateError() {
		console.log('SPRAWDZENIE USŁUG - ERROR');
		send('NEXT');
	}
	function validate(config) {
		loading.start();
		if (config.deliveryType == 'home') {
			var data = {};
			if (!config.deliveryInfo.deliveryEqualsHome) {
				data = {
					cityName: $('#delivery-city-name').val(),
					zipCode: $('#delivery-zip-code').val()
				};
			} else {
				data = {
					cityName: $('#city-name').val(),
					zipCode: $('#zip-code').val()
				};
			}
			data.action = 'check_services_to_order_availability';
			$.ajax({
				url: '/order-path-servicesJsonTools.ltr',
				data: data,
				success: function (json) {
					validateSuccess(json);
				},
				error: function () {
					validateError();
				}
			});
		} else if (config.deliveryType == 'shop') {
			if (config.shopCode && ("" + config.shopCode).length) {
				$.ajax({
					url: '/order-path-validate-delivery-data.ltr',
					dataType: 'json',
					data: {
						shopCode: config.shopCode
					},
					success: function (data) {
						if (data.status === 'OK') {
							send('NEXT');
						} else if (data.status === 'SELECTED_SERVICES_IS_NOT_AVAILABLE_FOR_PICKUP_POINT_ERROR') {
							loading.stop();
							modal.generate({
								content: data.messages[0],
								buttons: [
									{
										text: 'Przejdź do koszyka',
										cssClass: 'btn-third',
										click: function () {
											modal.close();
											loading.redirect({
												href: "/cart.bhtml",
												soft: true
											});
										}
									},
									{
										text: 'Zmień punkt odbioru',
										cssClass: 'btn-primary',
										click: function () {
											modal.close();
										}
									}
								]
							});
						} else {
							modal.alert('Brak obsługi odpowiedzi')
						}
					}, error: function () {
						modal.alert('Brak weryfikacji poprawności danych. Spróbuj ponownie')
					}
				});
			} else {
				modal.alert('Nie wybrano sklepu. Spróbuj ponownie wybrać sklep');
			}
		} else {
			send('NEXT');
		}
	}
	function send(action) {
		if (orderConfig.getData().operatorClientNoMail) {
			$('#paper-invoice-status').val(true);
		}
		orderUtils.send(action);
	}
	return {
		validate
	};
});
